import { Component, input } from '@angular/core';

@Component({
  standalone: false,
  template: '',
})
export class BaseMenuItemComponent {
  title = input<string>();
  icon = input<string>();
  active = input<boolean>();
}
